<template>
  <div class="account-service-wrap">
    <div class="row row-header">
      <div class="col-xs-12 col-md-2">Prašymo numeris</div>
      <div class="col-xs-12 col-md-3 text-left">Konkursas</div>
      <div class="col-xs-12 col-md-2 text-right">Pasiūlyta kaina</div>
      <div class="col-xs-12 col-md-3 text-left">Būsena</div>
      <div class="col-xs-12 col-md-2 text-right">Veiksmai</div>
    </div>
    <div
      v-for="tender in tenders.data"
      :key="tender.id"
      class="row row-service"
    >
      <div class="col-xs-12 col-md-2">
        <div class="dash-reference">
          {{ tender.reference ? tender.reference : '-' }}
        </div>
        <div class="dash-placed-at">{{ tender.register_at }}</div>
      </div>
      <div class="col-xs-12 col-md-3 text-left">
        <a
          v-if="!isTenderArchived(tender) && tender.tender.tender_url"
          :href="`/${tender.tender.tender_url}`"
          class="tender-link"
        >
          {{ tender.name }}
        </a>
        <span v-else>
          {{ tender.name }}
        </span>
      </div>
      <div class="col-xs-12 col-md-2 text-right">
        {{ tender.offered_price }} EUR
        <template v-if="tender.order_status == 'payment-received'">
          <span>
            <span class="badge badge-payment_received">Apmokėta</span>
          </span>
        </template>
      </div>
      <div class="col-xs-12 col-md-3 text-left">
        <template v-if="tender.order_status == 'pending'">
          <span v-html="statusRender('payment_pending')"></span>
        </template>
        <template v-else-if="tender.init_pay && !tender.payment_received">
          <span v-html="statusRender('payment_pending')"></span>
        </template>
        <template v-else>
          <span v-html="statusRender(tender.status)"></span>
          <div
            v-if="
              tender.status === 'rejected' || tender.status === 'revise_expired'
            "
            class="small text-muted text-comments"
            v-html="tender.canceled_comments"
          ></div>
          <div
            v-if="tender.status === 'revise'"
            class="small text-muted text-comments"
            v-html="tender.revise_comments"
          ></div>
        </template>
      </div>
      <div class="col-xs-12 col-md-2 text-right">
        <button
          v-if="tender.init_pay && !tender.payment_received"
          v-b-tooltip.hover
          title="Apmokėti"
          class="btn-action btn-action-pay"
          @click="addTenderToCart(tender)"
        >
          <i class="fas fa-cart-plus"></i>
        </button>
        <a
          v-b-tooltip.hover
          :href="`/account/tenders/${tender.id}/submit-review`"
          :title="$t('buttons.preview')"
          class="btn-action btn-action-preview"
        >
          <i class="fas fa-eye"></i>
        </a>
        <a
          v-if="!tender.locked && isEditingAllowed(tender)"
          v-b-tooltip.hover
          :href="`/account/tenders/${tender.id}/edit`"
          :title="$t('buttons.edit')"
          class="btn-action btn-action-edit"
        >
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a
          v-if="
            !tender.locked &&
            tender.status !== 'revise' &&
            tender.status !== 'revise_expired'
          "
          v-b-tooltip.hover
          v-confirm="{
            html: true,
            okText: 'Trinti',
            cancelText: 'Atšaukti',
            message: `Ar tikrai norite ištrinti prašymo <strong>${tender.name}</strong> įrašą ?`,
            animation: 'zoom',
          }"
          :href="`/account/tenders/${tender.id}/delete-record`"
          class="btn-action btn-action-delete"
          :title="$t('buttons.delete')"
        >
          <i class="fas fa-trash-alt"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountTenders',
  title: '',
  components: {},
  props: {
    tenders: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selected: [],
      window: {
        width: 0,
        height: 0,
      },
      icons: {
        opened: '<i class="fas fa-chevron-up"></i>',
        closed: '<i class="fas fa-chevron-down"></i>',
      },
    }
  },
  computed: {},
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted() {},
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    isTenderArchived(tender) {
      // Check if tender is archived based on status or archived flag
      return tender.tender_status === 'archived'
    },
    isEditingAllowed(tender) {
      console.log('isEditingAllowed method called for tender:', tender)
      // Temporarily return false to test if the method is working
      return false
    },
    addTenderToCart(form) {
      this.$store.dispatch('basket/addToBasket', {
        record_type: 'record_pay',
        record_id: form.fid,
        code: form.tender_id,
        name: form.name,
        quantity: 1,
        price:
          form.user_price_enabled && form.price_user
            ? form.price_user
            : form.price,
        line_total: 1,
      })
      this.$emit('close')
    },
    statusRender(status) {
      return (
        '<span class="badge badge-' +
        status +
        '">' +
        this.$t('tenders.status.' + status) +
        '<span>'
      )
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight - 50
    },
    toggleShowFilters() {},
  },
}
</script>

<style scoped>
.tender-link {
  color: #164194;
  text-decoration: none;
  font-weight: 500;
}

.tender-link:hover {
  color: #0d2a5e;
  text-decoration: underline;
}

.tender-link:visited {
  color: #164194;
}
</style>
